import { escapeCsvField } from './orderCsvExport';
import { downloadCsv } from './csv';

const fmtMins = (m) => {
  if (!m || m <= 0) return '0m';
  const h = Math.floor(m / 60);
  const mm = Math.round(m % 60);
  return h > 0 ? `${h}h ${mm}m` : `${mm}m`;
};

const DOW = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

/**
 * Sectioned CSV for a driver's stats — mirrors the partner/global stats export
 * style (header block + KPI table + breakdown tables).
 */
export function downloadDriverStatsCsv(stats, { driverName } = {}) {
  if (!stats) return;
  const rows = [];
  const push = (...cells) => rows.push(cells.map(escapeCsvField).join(','));

  push('# OVO Driver Stats Export');
  push('Driver', driverName || stats.driver?.name || '');
  const p = stats.period || {};
  push('Period', p.from ? `${p.from} -> ${p.to}` : 'All time');
  push('');

  push('Section', 'Metric', 'Value');
  const d = stats.delivery || {};
  push('Delivery', 'Total deliveries', d.total ?? 0);
  push('Delivery', 'Completed', d.completed ?? 0);
  push('Delivery', 'Failed', d.failed ?? 0);
  push('Delivery', 'Skipped', d.skipped ?? 0);
  push('Delivery', 'Completion rate (%)', d.completionRate ?? 0);
  const r = stats.routes || {};
  push('Routes', 'Routes', r.total ?? 0);
  push('Routes', 'Avg stops / route', r.avgStopsPerRoute ?? 0);
  push('Routes', 'Total distance (km)', r.totalDistanceKm ?? 0);
  push('Routes', 'Driven time', fmtMins(r.totalDrivenMins));
  push('Routes', 'Avg driven / route', fmtMins(r.avgDrivenMinsPerRoute));
  push('Routes', 'Client service time', fmtMins(r.totalClientServiceMins));
  push('Routes', 'Avg client service / route', fmtMins(r.avgClientServiceMins));
  push('Routes', 'CO2 (kg)', r.totalCo2Kg ?? 0);
  push('Routes', 'CO2 saved vs car (kg)', r.totalCo2SavedKg ?? 0);
  push('Routes', 'Paused time', fmtMins(r.totalPausedMins ?? 0));
  const punct = stats.punctuality;
  if (punct) {
    push('Punctuality', `On-time starts (<=${punct.thresholdMins}min) %`, punct.onTimeStartRate ?? '');
    push('Punctuality', 'Avg start delay (min)', punct.avgStartDelayMins ?? '');
    push('Punctuality', 'Late starts', punct.lateStarts ?? 0);
    push('Punctuality', 'Start not badged', punct.startNotBadged ?? 0);
    push('Punctuality', 'Worst start delay (min)', punct.worstStartDelayMins ?? '');
  }
  push('');

  push('By status', 'Status', 'Count');
  Object.entries(stats.activity?.ordersByStatus || {}).forEach(([s, v]) => push('By status', s, v));
  push('');

  push('By day of week', 'Day', 'Deliveries');
  (stats.activity?.ordersByDayOfWeek || []).forEach((v, i) => push('By day of week', DOW[i], v));
  push('');

  push('By partner', 'Partner', 'Code', 'Total', 'Completed', 'Failed', 'Skipped', 'Completion %');
  (stats.byPartner?.rows || []).forEach((row) =>
    push('By partner', row.name, row.code || '', row.total, row.completed, row.failed, row.skipped, row.completionRate),
  );

  const slug = (driverName || stats.driver?.name || 'driver').replace(/[^a-z0-9]+/gi, '-').toLowerCase();
  downloadCsv(rows, `stats-${slug}.csv`);
}
